import { Component, ElementRef, inject, Input, QueryList, ViewChildren } from '@angular/core';
import { gsap, Expo, Quad } from 'gsap';
import { Movie, PageService, TopPromo } from '../../services/Page/page.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { BackgroundVideoService } from '../../services/BackgroundVideo/background-video.service';
import { VideoPlayPauseButtonComponent } from "../video-play-pause-button/video-play-pause-button.component";
import { MatIconModule } from '@angular/material/icon';
import { BookingService } from '../../services/Booking/booking.service';
import { AddLargeComponent } from "../UI/add-large/add-large.component";


@Component({
    selector: 'app-top-slider',
    imports: [
    CommonModule,
    RouterModule,
    VideoPlayPauseButtonComponent,
    MatIconModule,
    AddLargeComponent
],
    templateUrl: './top-slider.component.html',
    styleUrl: './top-slider.component.scss'
})
export class TopSliderComponent {
    @ViewChildren("videoEl") videoEl: QueryList<ElementRef> | undefined;
    
    @Input('isMobile') isMobile: boolean = false;
    @Input('isMinimal') isMinimal : boolean = false 
    @Input('topPromo') topPromo: TopPromo[] = []

    selected: number = 0
    timeoutIndex: any
    private router = inject(Router);
    isAutoplayVideo: boolean = true

    movie: Movie = new Movie()

    constructor(
        public pageService: PageService,
        public backgroundVideoService: BackgroundVideoService,
        public bookingService: BookingService,
    ) {

    }

    ngOnInit(): void {
        this.pageService.homePage$.subscribe(data => {
            if(data != null) {
                gsap.set('.TopSlider .slides', { width: 100 * (this.topPromo.length) + '%' });
            }
        })

        this.backgroundVideoService.isPlaying$.subscribe(isPlaying => {
            console.log('home page is Playing', isPlaying);
            if (this.isAutoplayVideo) {
                isPlaying ? this.videoEl?.toArray()[0]?.nativeElement.play() : this.videoEl?.toArray()[0]?.nativeElement.pause();
            }
            else {
                this.videoEl?.toArray()[0]?.nativeElement.pause();
            }

        });
        // setTimeout(() => {
            
            // this.loop();
        // }, 6000);
    }

    ngOnDestroy(): void {
        clearTimeout(this.timeoutIndex);
    }

    onSelect(i: number) {
        let speed0 = !this.isMobile ? 0.8 : 0.4
        let speed1 = !this.isMobile ? 0.6 : 0.3
        let speed2 = !this.isMobile ? 1 : 0.5

        if (i != this.selected) {

            let dir = -1;


            // gsap.to('.TopSlider .slides', speed0, { x: -i * 100 / (this.topPromo.length) + '%', ease: Quad.easeOut });
            gsap.to('.TopSlider .slides', speed0, { x: -i * 100  + 'vw', ease: Quad.easeOut });

            this.selected = i
        }

        // this.loop()

    }

    next() {
        if (this.selected < this.topPromo.length - 1) {
            this.onSelect(this.selected + 1)
        }
        else {
            this.onSelect(0)
        }
    }

    prev() {
        if (this.selected == 0) {
            this.onSelect(this.topPromo.length - 1)
        }
        else {
            this.onSelect(this.selected - 1)
        }
    }

    loop() {
        clearTimeout(this.timeoutIndex);

        this.timeoutIndex = setTimeout(() => {
            this.next()

        }, 5000);
    }

    onVideoEnded(e: Event) {
        console.log('Video ended')
        // this.next()
    }

    onBookNow() {
        // this.pageService.getMoviesByIds([this.topPromo[0].Dx]).then(movies => {
            this.movie = this.topPromo[this.selected].movie
            this.bookingService.open(this.movie) 
        // })
    }
}
